@import '../../theme/global';

:host {
  display: flex;
  @include button-reset;

  .snap-card-product {
    align-items: center;
    margin-right: 1rem;

    svg {
      height: 2.5rem;
      width: 62.5px;
      @media (max-width: map-get($breakpoints, 'sm')) {
        height: 4rem;
        width: 100px;
      }
    }
  }

  snap-avatar {
    align-items: center;
    margin-right: 1rem;

  }
  @media (min-width: map-get($breakpoints, 'md')) {
    snap-avatar {
      .snap-avatar {
        height: 64px;
        width: 64px;
      }
    }
  }
}
